<template>
  <div v-if="!isEmpty" class="my-pop-alert-body">
    <div class="delete-my-alert">
      <button type="button" @click.prevent="clickAllDelete()">모두 삭제</button>
    </div>

    <div class="popup-scroll" ref="popupScroll">
      <div class="pop-alert-wrap-pb">
        <div
          class="pop-alert-wrap"
          v-for="(data, index) in dataList"
          :key="index"
          :index="index"
        >
          <p class="pop-alert-date">
            <span class="ic-clock"
              ><img
                src="../../assets/images/mypooq/mypooq-icon-clock.png"
                alt="시계 아이콘"
            /></span>
            {{ data.date }}
          </p>
          <ul class="pop-alert-list">
            <li v-for="(item, index) in data.list" :key="index">
              <div
                :class="
                  item.alarmtype === 'marketing'
                    ? 'pop-list-wrap pop-con-back'
                    : 'pop-list-wrap'
                "
              >
                <a
                  href="#"
                  @click.prevent="clickAlarm(item)"
                  class="pop-alert-con"
                >
                  <span class="pop-alert-con-tit">{{ item.content }}</span>
                  <span class="pop-alert-con-date">{{ item.datestring }}</span>
                </a>
                <button
                  @click.stop="clickDelete(item, index)"
                  class="pop-alert-delete"
                >
                  <img
                    src="../../assets/images/mypooq/ico-notice-delete.png"
                    alt="알림 개별 삭제 아이콘"
                  />
                </button>
                <div class="pop-arrow-line"></div>
                <div class="pop-arrow-bg"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 페이징 -->
      <paging-component
        v-if="!isLoading && isPageShow"
        :current-page="currentPage"
        :page-count="pageCount"
        :limit="limit"
        :paging-count="10"
        :isLoading="false"
        :custom-change-page-fn="callApi"
        :custom-event-type="ALARM_PAGING_UPDATE"
        wrapper-class="paging-type02"
      />
    </div>
  </div>

  <div v-else class="my-pop-alert-empty">
    <img src="../../assets/images/mypooq/icon-error-74.png" alt="에러 아이콘" />
    <p>알림 내역이 없어요</p>
  </div>
</template>

<script>
  import PagingComponent from '@/components/common/PagingComponent'
  import {
    deleteAlarmsDetail,
    deleteAlarms,
    getAlarms,
    postAlarms,
  } from '@/common/utils/request'
  import { clickLink } from '@/common/utils/common'
  import _ from 'lodash'
  export default {
    components: {
      PagingComponent,
    },
    data() {
      return {
        dataList: [],
        offset: 0,
        limit: 20,
        dayWeek: ['일', '월', '화', '수', '목', '금', '토'],
        currentPage: 1, // 페이지 번호,
        pageCount: 0,
        isLoading: false,
        isError: false,
        ALARM_PAGING_UPDATE: 'alarm_paging_update',
      }
    },
    computed: {
      isPageShow() {
        return !(this.currentPage === 1 && this.pageCount <= this.limit)
      },
      isEmpty() {
        return this.isLoading ? false : this.dataList?.length <= 0
      },
    },
    methods: {
      clickAlarm(item) {
        if (item.alarmtype === 'baseball_live') {
          alert(
            '야구 서비스는 모바일 전용 기능입니다.   \n' +
              '모바일 App으로 확인해주세요.',
          )
          return false
        } else {
          clickLink(item.targeturl)
        }
      },
      clickDelete(item, index) {
        if (confirm('알림을 삭제하시겠습니까?')) {
          deleteAlarmsDetail({ alarmid: item.alarmid }).then(() => {
            this.dataList.splice(index, 1)
            // 데이터 리스트에서 선택된 알림 삭제
            this.dataList.forEach((data, dataIndex) => {
              data.list.forEach((alarm, alarmIndex) => {
                if (alarm.alarmid === item.alarmid) {
                  data.list.splice(alarmIndex, 1)
                }

                // 삭제된 알림이 속한 날짜 그룹의 길이가 0이면 날짜 그룹도 삭제
                if (data.list.length === 0) {
                  this.dataList.splice(dataIndex, 1)
                }
              })
            })
            this.callApi(this.currentPage)
          })
        }
      },
      // 알림 삭제 후 API 재호출
      clickAllDelete() {
        if (confirm('모든 알림을 삭제하시겠습니까?')) {
          deleteAlarms({ status: 'all' }).then(() => {
            this.dataList = undefined
            this.callApi(this.currentPage)
          })
        }
      },
      callApi(currentPage) {
        this.isLoading = true
        const offset = (currentPage - 1) * this.limit
        this.currentPage = currentPage
        getAlarms({ offset, limit: this.limit })
          .then(({ data }) => {
            this.dataList = _.get(data, 'list', [])
            this.pageCount = Number(_.get(data, 'pagecount', '0')) // 53
            let tempList = []
            let checkDate = ''

            _.get(data, 'list', []).forEach((data) => {
              if (checkDate === _.get(data, 'date', '')) {
                let tempData = tempList[tempList.length - 1]
                tempData.list.push(data)
              } else {
                let day = new Date(data.date)
                checkDate = data.date
                tempList.push({
                  date:
                    data.date.substr(5, 11) +
                    ' ' +
                    this.dayWeek[day.getDay()] +
                    '요일',
                  list: [data],
                })
              }
            })
            this.dataList = tempList
            this.isLoading = false
            if (
              this.dataList.length === 0 &&
              offset !== 0 &&
              this.currentPage !== 1
            ) {
              this.callApi(this.currentPage - 1)
            }
            if (this.dataList.length > 0) {
              this.$nextTick(() => {
                this.$refs.popupScroll.scrollTo(0, 0)
              })
            }
          })
          .catch(() => {
            this.isLoading = false
            this.isError = true
          })
      },
    },
    created() {
      postAlarms()
      this.callApi(this.currentPage)
    },
    mounted() {
      this.$events.$on(this.ALARM_PAGING_UPDATE, () => {
        this.callApi(this.currentPage)
      })
    },
  }
</script>

<style lang="css" scoped>
  .paging-type01.paging-player {
    margin: 0 auto 40px !important;
  }
  .paging-type01 a.on {
    border: 1px solid #1351f9;
    color: #1351f9;
  }
</style>
